export default __webpack_public_path__ + "static/try_rootstock-ee7a0a9555720e5fc5d25de99f2e7d52.svg";